module.exports = __webpack_public_path__ + "img/video-btn.f882cb2c.png";